import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import { spacing, Text, typography, Visible } from 'main/ui'
import { useTranslation } from 'react-i18next'
import {
  Break,
  Graphic,
  GraphicsContainer,
  LinkContainer,
  StyledLink,
  StyledText,
  TextContainer,
  ValuePropContainer,
} from './ValueProp.styles'

const PRE = `${i18nKeyPrefix}-SAVE-VALUE-PROP`

export default function ValueProp() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <ValuePropContainer>
      <GraphicsContainer>
        <Graphic src="https://ucarecdn.com/c15f8ab9-0ab2-46d5-9c6b-89b0fed67377/" />
      </GraphicsContainer>
      <Visible lg xl>
        <Break />
      </Visible>
      <TextContainer>
        <StyledText>{t(`${PRE}-TEXT`)}</StyledText>
        <Visible md lg xl>
          <LinkContainer>
            <Text css={{ fontWeight: typography.fontWeight.light }}>{t(`${PRE}-MORE`)}</Text>
            <StyledLink
              hasBorderRight
              href="/p/child-care-provider-resources/what-is-family-child-care"
              target="_blank"
            >
              {t(`${PRE}-BENEFITS`)}
            </StyledLink>
            &nbsp;
            <StyledLink css={{ marginLeft: spacing.minorScale(1) }} href="/safety" target="_blank">
              {t(`${PRE}-VISION`)}
            </StyledLink>
          </LinkContainer>
        </Visible>
      </TextContainer>
    </ValuePropContainer>
  )
}
